import React from "react";
import { motion } from "framer-motion";
import {
  FaCogs,
  FaShieldAlt,
  FaAward,
  FaCheckCircle,
  FaRocket,
  FaTools,
  FaWrench,
} from "react-icons/fa";
import AutoTwo from "../../../assets/dexter-images/auto-mobile-2.jpg";
import Medical from "../../../assets/dexter-images/medical.jpg";

function RawMaterials() {
  return (
    <div className="service-page raw-materials-page">
      <motion.div
        className="service-hero"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="hero-content">
            <h1>Processed Raw Materials & Treatments</h1>
            <p>
              Comprehensive Material Processing with Advanced Surface Treatments
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="service-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <div className="container">
          {/* Hero Section with Image */}
          <div className="service-hero-section">
            <div className="hero-text">
              <h2>Material Sourcing Excellence</h2>
              <p>
                DexteR Technology specializes in sourcing and processing
                high-quality raw materials according to ASTM and AMS standards.
                Our comprehensive material processing capabilities ensure
                optimal performance and durability for all manufactured
                components.
              </p>
              <div className="hero-features">
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>ASTM & AMS Standards</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Advanced Processing</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Quality Certified</span>
                </div>
              </div>
            </div>
            <div className="hero-image">
              <img src={AutoTwo} alt="Raw Material Processing" />
            </div>
          </div>

          {/* Materials Processing */}
          <div className="capabilities-section">
            <h2>Materials We Process</h2>
            <div className="capabilities-grid">
              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaShieldAlt />
                </div>
                <h3>Stainless Steel (SS)</h3>
                <p>
                  High-quality stainless steel processing with excellent
                  corrosion resistance and durability
                </p>
                <ul>
                  <li>Grade 304 & 316</li>
                  <li>Precision machining</li>
                  <li>Surface finishing</li>
                  <li>Quality verification</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaCogs />
                </div>
                <h3>Aluminum</h3>
                <p>
                  Lightweight aluminum processing with excellent
                  strength-to-weight ratio and conductivity
                </p>
                <ul>
                  <li>6061 & 7075 grades</li>
                  <li>Precision cutting</li>
                  <li>Heat treatment</li>
                  <li>Anodizing options</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaAward />
                </div>
                <h3>Brass</h3>
                <p>
                  Precision brass processing with excellent conductivity and
                  corrosion resistance
                </p>
                <ul>
                  <li>360 & 260 grades</li>
                  <li>Precision turning</li>
                  <li>Surface polishing</li>
                  <li>Quality inspection</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaTools />
                </div>
                <h3>Gun Metal</h3>
                <p>
                  Specialized gun metal processing for specific industrial
                  applications and requirements
                </p>
                <ul>
                  <li>Custom compositions</li>
                  <li>Precision casting</li>
                  <li>Surface treatments</li>
                  <li>Quality testing</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaWrench />
                </div>
                <h3>Mild Steel (MS)</h3>
                <p>
                  Cost-effective mild steel processing for various industrial
                  applications and components
                </p>
                <ul>
                  <li>Multiple grades</li>
                  <li>Precision machining</li>
                  <li>Surface treatments</li>
                  <li>Quality control</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaRocket />
                </div>
                <h3>Custom Alloys</h3>
                <p>
                  Specialized custom alloy processing for unique requirements
                  and applications
                </p>
                <ul>
                  <li>Custom compositions</li>
                  <li>Specialized processing</li>
                  <li>Quality verification</li>
                  <li>Performance testing</li>
                </ul>
              </motion.div>
            </div>
          </div>

          {/* Process Image */}
          <div className="process-image-section">
            <motion.div
              className="process-image"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={Medical} alt="Material Processing Facility" />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>Advanced Material Processing</h3>
                  <p>
                    State-of-the-art material processing with quality assurance
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Surface Treatments */}
          <div className="materials-section">
            <h2>Surface Treatments & Finishing</h2>
            <div className="materials-grid">
              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaShieldAlt />
                </div>
                <h3>Anodizing</h3>
                <p>
                  Aluminum anodizing for enhanced corrosion resistance and
                  surface hardness
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaCogs />
                </div>
                <h3>Plating</h3>
                <p>
                  Electroplating services including chrome, nickel, and zinc
                  plating
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaAward />
                </div>
                <h3>Polishing</h3>
                <p>
                  Precision surface polishing for enhanced appearance and
                  performance
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaTools />
                </div>
                <h3>Heat Treatment</h3>
                <p>
                  Controlled heat treatment processes for improved material
                  properties
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaWrench />
                </div>
                <h3>Passivation</h3>
                <p>
                  Stainless steel passivation for enhanced corrosion resistance
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaRocket />
                </div>
                <h3>Custom Finishes</h3>
                <p>
                  Specialized surface treatments designed for specific
                  applications
                </p>
              </motion.div>
            </div>
          </div>

          {/* Material Specifications */}
          <div className="specs-section">
            <h2>Material Specifications & Standards</h2>
            <div className="specs-grid">
              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h3>ASTM Standards</h3>
                <p>
                  Compliance with ASTM standards for material composition and
                  properties
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h3>AMS Specifications</h3>
                <p>
                  Aerospace Material Specifications for high-performance
                  applications
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h3>Quality Certification</h3>
                <p>
                  Certified material processing with comprehensive quality
                  control
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <h3>Traceability</h3>
                <p>
                  Complete material traceability from sourcing to final
                  processing
                </p>
              </motion.div>
            </div>
          </div>

          {/* Why Choose Us Section */}
          <div className="why-choose-section">
            <h2>Why Choose Our Material Processing Services?</h2>
            <div className="benefits-grid">
              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Quality Standards</h3>
                <p>
                  Strict adherence to ASTM and AMS standards for material
                  quality
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Advanced Processing</h3>
                <p>State-of-the-art processing equipment and techniques</p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Custom Solutions</h3>
                <p>Tailored material processing for specific requirements</p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Quality Assurance</h3>
                <p>
                  Comprehensive testing and verification of processed materials
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default RawMaterials;
